import { EventEmitter, OnChanges, Output } from "@angular/core";
import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BcRevenueTransactionsData } from "../../../../core/models/bcLedgers/BcRevenueTransactionsResponseDto";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { AdjustmentsRequestDto } from "../../../../core/models/bcLedgers/adjustmentsRequestDto";
import { BcLedgerStacker } from "../../../../core/models/bcLedgers/bcLedgerStacker";
import { LoaderService } from "../../../../core/services/loader.service";
import { BcRevenueTransactionsComponent } from "../bc-revenue-transactions/bc-revenue-transactions.component";
import { BcledgerService } from "../../../../core/services/bcledger.service";

@Component({
  selector: "jni-adjustments",
  templateUrl: "./adjustments.component.html",
  styleUrls: ["./adjustments.component.scss"],
  imports: [BcRevenueTransactionsComponent],
})
export class AdjustmentsComponent implements OnInit, OnChanges {
  @Input() bcLedgerStacker!: BcLedgerStacker;
  adjustmentsParams!: AdjustmentsRequestDto;
  adjustmentsList: BcRevenueTransactionsData[] = [];
  TotalBCRevenue!: number;
  TotalBCGP!: number;
  BCAvgMargin!: number;
  TotalBCCommission!: number;
  TotalBCReserve!: number;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _toastrService: JniToastrService,
    private _loaderService: LoaderService,
    private _adjustmentsService: BcledgerService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.adjustmentsParams = { ...params } as AdjustmentsRequestDto;
      this.adjustmentsParams.CategoryID = "";
    });
  }

  ngOnInit(): void {
    this.getAdjustments(this.adjustmentsParams);
  }

  getAdjustments(payload: AdjustmentsRequestDto) {
    this._loaderService.setLoaderState(true);
    this._adjustmentsService.adjustments(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.adjustmentsList = res.data.Data ?? [];
          this.TotalBCRevenue = res.data.TotalBCRevenue;
          this.TotalBCGP = res.data.TotalBCGP;
          this.BCAvgMargin = res.data.BCAvgMargin;
          this.TotalBCCommission = res.data.TotalBCCommission;
          this.TotalBCReserve = res.data.TotalBCReserve;
          return;
        }
        this._toastrService.error(
          res.message ?? "Adjustments Fetched",
          "Adjustments"
        );
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastrService.error("No results found", "Error");
      },
    });
  }

  ngOnChanges() {
    if (this.bcLedgerStacker) {
      this.adjustmentsParams = { ...this.bcLedgerStacker };
      this.adjustmentsParams.CategoryID = "";
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
